import debounce from 'lodash.debounce';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useSearchUserstories } from 'src/queries/userstory';
import { UserStory } from 'src/types/epic';

export default function ActivitiesPage() {
  const [userstories, setUserstories] = useState<UserStory[]>([]);
  const searchInputRef = useRef<any>();
  const { mutate: searchRequest, data: searchedData } = useSearchUserstories();

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const searchedValue = e.target.value;
    searchRequest({ search: searchedValue });
  };

  const debouncedChangeInput = debounce(handleSearch, 700);

  useEffect(() => {
    if (!searchedData) return;
    setUserstories(searchedData);
  }, [searchedData]);

  useEffect(() => {
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      searchInputRef.current.value = '';
    };
  }, []);

  return (
    <div className="pt-5 pb-5">
      <div className="flex flex my-5 justify-between">
        <input
          className="input w-full input-bordered"
          placeholder="جستجو..."
          onChange={debouncedChangeInput}
          ref={searchInputRef}
        />
      </div>

      <div className="mt-5">
        <ul className="menu bg-base-100 w-full rounded-box">
          {userstories.map((userstory) => {
            const epicId = userstory.epics[0].id;
            return (
              <li
                className="border-2"
                key={userstory.id}
              >
                <a
                  href={`/activities/${userstory.id}/ref/${userstory.ref}/epic/${epicId}`}
                  className="flex flex-col items-start p-3"
                >
                  <h3 className="w-full text-right flex flex-wrap">
                    <span>{userstory.subject}</span>
                  </h3>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
